module.exports = __webpack_public_path__ + "static/media/resume.bfc6269e.pdf";